const navLinks = {
	defaultLinks: [
		{
			name: "Create a Team",
			to: "/createteam",
		},
		{
			name: "Join a Team",
			to: "/user_onboarding",
		}
	],
};

export default navLinks;
